module.exports = __webpack_public_path__ + "img/314.5c0a0a9d.png";